<script setup lang="ts">
import type { ProjectSummary, SiteSettings } from '~/types/content'

useSeoMeta({
  title: 'Shakir Abdulrahim — Full-Stack Developer & Hardware Tinkerer',
  ogTitle: 'Shakir Abdulrahim — Full-Stack Developer & Hardware Tinkerer',
  description: 'Full-stack web developer and hardware tinkerer with 10 years of experience in web applications, Legal Tech, IoT/embedded engineering, and AI.',
  ogDescription: 'Full-stack web developer and hardware tinkerer with 10 years of experience in web applications, Legal Tech, IoT/embedded engineering, and AI.',
})

const { data: settings } = await useFetch<SiteSettings>('/api/settings')
const stats = computed(() => settings.value?.stats ?? [])

const { data: featuredProjects } = await useFetch<ProjectSummary[]>('/api/projects', {
  query: { featured: 'true' },
  default: () => [],
})

useScrollReveal()
</script>

<template>
  <div>
    <HomeHero />
    <HomeStats :stats="stats" />
    <HomeFeatured :projects="featuredProjects" />
    <HomeFocus />
  </div>
</template>
